// Custom Scroll
$(function() {
	$('.customScroll').slimScroll({
		height: "300px",
		color: '#e5e8f2',
		alwaysVisible: false,
		size: "7px",
		distance: '1px',
		railVisible: false,
		railColor: "#4266b2",
	});
});

// Custom Scroll 2
$(function() {
	$('.customScroll2').slimScroll({
		height: "224px",
		color: '#e5e8f2',
		alwaysVisible: false,
		size: "7px",
		distance: '1px',
		railVisible: false,
		railColor: "#4266b2",
	});
});

// Custom Scroll 3
$(function() {
	$('.customScroll3').slimScroll({
		height: "245px",
		color: '#e5e8f2',
		alwaysVisible: false,
		size: "7px",
		distance: '1px',
		railVisible: false,
		railColor: "#4266b2",
	});
});


// Custom Scroll
$(function() {
	$('.sidebarNavScroll').slimScroll({
		height: "calc(100vh - 300px)",
		color: '#3b4c63',
		alwaysVisible: false,
		size: "8px",
		distance: '1px',
		railVisible: false,
		railColor: "#4266b2",
	});
});

